var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',{ref:"textarea",staticClass:"text-area-study",style:(_vm.setStyle),attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }